import { tracker } from "@pjs/analytics";
import { ISettingSaveItem } from "../interfaces/setting-items/ISettingSaveItem";

export const trackSaveAnalytics = (changes: ReadonlyArray<ISettingSaveItem>): void => {
    for (const change of changes) {
        tracker.trackEvent("User Settings", "Save account settings", change.name);
    }
};
